import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/kennels/sites-all';

  return API({ endpoint });
}
